import { render, staticRenderFns } from "./MapCamera.vue?vue&type=template&id=387c6f12&scoped=true&"
import script from "./MapCamera.vue?vue&type=script&lang=js&"
export * from "./MapCamera.vue?vue&type=script&lang=js&"
import style0 from "./MapCamera.vue?vue&type=style&index=0&id=387c6f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c6f12",
  null
  
)

export default component.exports